import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';
import pym from 'pym.js';
import { Component, createRef } from 'react';

import { navigate } from './helpers/sticky_nav';

export class IFramedForm extends Component {
  constructor(props) {
    super(props);

    this.uniqueId = `iframe_${kebabCase(props.src.split('?')[0])}`;
    this.containerRef = createRef();
  }

  // eslint-disable-next-line react/sort-comp
  createPym = () => {
    this.pym = new pym.Parent(this.uniqueId, this.props.src, {
      title: this.props.title,
    });

    if (this.props.scrollOnSuccess) {
      this.pym.onMessage('success', success => {
        if (success) {
          navigate(this.uniqueId);
          if (this.props.reloadOnSuccess) {
            setTimeout(
              () => window.location.reload(),
              typeof this.props.reloadOnSuccess === 'number' ? this.props.reloadOnSuccess : 30000
            );
          }
        }
      });
    }
  };

  componentDidMount() {
    this.createPym();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.src !== prevProps.src) {
      this.pym?.remove();
      this.createPym();
    }
    if (this.props.title !== prevProps.title) {
      this.setIframeTitle();
    }
  }

  componentWillUnmount() {
    this.pym?.remove();
  }

  setIframeTitle = () => {
    if (this.props.title) {
      const container = document.getElementById(this.uniqueId);
      if (container) {
        const iframe = container.querySelector('iframe');
        if (iframe) {
          iframe.setAttribute('title', this.props.title);
          return true;
        }
      }
    }
    return false;
  };

  render() {
    return <div ref={this.containerRef} id={this.uniqueId} data-src={this.props.src} />;
  }
}

IFramedForm.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  scrollOnSuccess: PropTypes.bool,
  reloadOnSuccess: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default IFramedForm;
